import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 用户登录接口 
export const userLogin = (params) => { return loginreq("post", "/admin/login/userLogin", params) };
// 专家登录接口 
export const agentLogin = (params) => { return loginreq("post", "/admin/login/agentLogin", params) };
// 管理登录接口 
export const adminLogin = (params) => { return loginreq("post", "/admin/login/adminLogin", params) };
// 获取验证码 
export const getVerifyCode = (params) => { return loginreq("post", "/admin/login/getCode", params) };
// 用户注册 
export const userRegister = (params) => { return loginreq("post", "/admin/login/userRegister", params) };
// 获取ICP备案信息 
export const getIPCConfig = (params) => { return loginreq("post", "/admin/login/getIPCConfig", params) };


// 用户相关接口开始

// 获取用户菜单权限
export const getUserAuthMenu = (params) => { return req("post", "/admin/user/getUserAuthMenu", params) };
// 获取用户基本信息
export const getUserInfo = (params) => { return req("post", "/admin/user/getUserInfo", params) };
// 编辑用户基本信息
export const editUserInfo = (params) => { return req("post", "/admin/user/editUserInfo", params) };
// 获取用户按钮权限
export const getUserAuthBtn = (params) => { return req("post", "/admin/user/getUserAuthBtn", params) };
// 编辑案件草稿箱(新增or修改)
export const editCaseDrafts = (params) => { return req("post", "/admin/cases/editCaseDrafts", params) };
// 删除案件草稿箱(单个)
export const delCaseDrafts = (params) => { return req("post", "/admin/cases/delCaseDrafts", params) };
// 删除案件草稿箱(勾选)
export const delCheckCaseDrafts = (params) => { return req("post", "/admin/cases/delCheckCaseDrafts", params) };
// 查询案件草稿箱列表
export const getPageCaseDrafts = (params) => { return req("post", "/admin/cases/getPageCaseDrafts", params) };
// 查询案件草稿详情
export const getDraftsInfo = (params) => { return req("post", "/admin/cases/getDraftsInfo", params) };
// 提交案件评估
export const commitCase = (params) => { return req("post", "/admin/cases/commitCase", params) };
// 创建支付订单
export const createOrder = (params) => { return req("post", "/admin/order/createOrder", params) };
// 查询订单详情
export const getOrderInfo = (params) => { return req("post", "/admin/order/getOrderInfo", params) };
// 积分支付订单
export const orderPayByPoints = (params) => { return req("post", "/admin/order/orderPayByPoints", params) };
// 查询下单配置
export const getOrderConfig = (params) => { return req("post", "/admin/order/getOrderConfig", params) };
// 查询客户发票抬头列表
export const getUserInvoicePageList = (params) => { return req("post", "/admin/user/getUserInvoicePageList", params) };
// 编辑客户发票抬头
export const editInvoice = (params) => { return req("post", "/admin/user/editInvoice", params) };
// 删除客户发票抬头
export const delInvoice = (params) => { return req("post", "/admin/user/delInvoice", params) };
// 用户修改密码
export const changeUserPassword = (params) => { return req("post", "/admin/user/changeUserPassword", params) };
// 查询案件记录(评估记录)
export const getPageEvaluateCase = (params) => { return req("post", "/admin/cases/getPageEvaluateCase", params) };
// 查询用户订单列表
export const getCusAdminOrderPageList = (params) => { return req("post", "/admin/order/getCusAdminOrderPageList", params) };
// 用户提交发票申请
export const addInvoiceApply = (params) => { return req("post", "/admin/user/addInvoiceApply", params) };
// 用户查看发票
export const getCusAdminApplyInvoice = (params) => { return req("post", "/admin/user/getCusAdminApplyInvoice", params) };
// 用户查询下级账户
export const getSubAccount = (params) => { return req("post", "/admin/user/getSubAccount", params) };
// 用户查询下属账户列表(账户管理)
export const getCusAdminPageList = (params) => { return req("post", "/admin/user/getCusAdminPageList", params) };
// 用户新增账户(账户管理)
export const editCusAdmin = (params) => { return req("post", "/admin/user/editCusAdmin", params) };
// 用户导入账户(账户管理)
export const importCusAdmin = (params) => { return req("post", "/admin/user/importCustomer", params) };
// 用户创建积分充值订单
export const createRechargeOrder = (params) => { return req("post", "/admin/order/createRechargeOrder", params) };
// 用户查询积分订单详情
export const getRechargeOrderInfo = (params) => { return req("post", "/admin/order/getRechargeOrderInfo", params) };
// 管理账户分配积分
export const distributionPoints = (params) => { return req("post", "/admin/user/distributionPoints", params) };
// 管理账户删除账户
export const delCusAdmin = (params) => { return req("post", "/admin/user/delCusAdmin", params) };
// 用户查询积分日志
export const getCusPointsLog = (params) => { return req("post", "/admin/user/getCusPointsLog", params) };
// 用户查询对公转账信息
export const getTransferAccountConfig = (params) => { return req("post", "/admin/user/getTransferAccountConfig", params) };
// 用户创建积分充值转账单
export const createRechargeTaxOrder = (params) => { return req("post", "/admin/order/createRechargeTaxOrder", params) };
// 用户查询积分充值订单
export const getCusAdminRechargeOrderPageList = (params) => { return req("post", "/admin/order/getCusAdminRechargeOrderPageList", params) };
// 用户查询评估案件详情
export const getCusEvalCaseData = (params) => { return req("post", "/admin/cases/getCusEvalCaseData", params) };
// 用户删除积分充值订单
export const cusDelChargeOrder = (params) => { return req("post", "/admin/order/delChargeOrder", params) };
// 用户查询可申请开发票的充值订单数据
export const getCanApplyTicketOrder = (params) => { return req("post", "/admin/user/getCanApplyTicketOrder", params) };
// 查询用户账户消息
export const getCustomerMessageList = (params) => { return req("post", "/admin/message/getCustomerMessageList", params) };

// 用户相关接口结束


// 管理端相关接口开始
// 查询管理账户基本信息
export const getAdminInfo = (params) => { return req("post", "/admin/admin/getAdminInfo", params) };
// 查询客户列表
export const getCustomerPageList = (params) => { return req("post", "/admin/admin/getCustomerPageList", params) };
// 查询角色列表
export const getSysRole = (params) => { return req("post", "/admin/admin/getSysRole", params) };
// 添加客户账户
export const editCustomer = (params) => { return req("post", "/admin/admin/editCustomer", params) };
// 导入客户账户
export const importCustomer = (params) => { return req("post", "/admin/admin/importCustomer", params) };
// 查询用户角色列表
export const getCusRole = (params) => { return req("post", "/admin/admin/getCustomerRole", params) };
// 查询用户上级账户列表
export const getSelectCustomer = (params) => { return req("post", "/admin/admin/getSelectCustomer", params) };
// 查询管理账户列表
export const getAdminPageList = (params) => { return req("post", "/admin/admin/getAdminPageList", params) };
// 编辑管理账户
export const editAdmin = (params) => { return req("post", "/admin/admin/editAdmin", params) };
// 编辑专家账户
export const editAgent = (params) => { return req("post", "/admin/admin/editAgent", params) };
// 查询专家账户列表
export const getAgentPageList = (params) => { return req("post", "/admin/admin/getAgentPageList", params) };
// 查询管理员案件列表
export const getSysCasePageList = (params) => { return req("post", "/admin/cases/getSysCasePageList", params) };
// 管理员修改密码
export const changeAdminPassword = (params) => { return req("post", "/admin/admin/changeAdminPassword", params) };
// 管理员手动充值积分
export const rechargePointsToCus = (params) => { return req("post", "/admin/admin/rechargePointsToCus", params) };
// 管理员查询系统配置列表
export const getSysConfigPageList = (params) => { return req("post", "/admin/admin/getSysConfigPageList", params) };
// 管理员编辑系统配置
export const editSysConfig = (params) => { return req("post", "/admin/admin/editSysConfig", params) };
// 管理员删除系统配置
export const delSysConfig = (params) => { return req("post", "/admin/admin/delSysConfig", params) };
// 管理员查询权限菜单列表
export const getPermissionPageList = (params) => { return req("post", "/admin/admin/getPermissionPageList", params) };
// 管理员编辑权限菜单
export const editPermission = (params) => { return req("post", "/admin/admin/editPermission", params) };
// 管理员删除权限菜单
export const delPermission = (params) => { return req("post", "/admin/admin/delPermission", params) };
// 管理员查询系统角色列表
export const getSysRolePageList = (params) => { return req("post", "/admin/admin/getSysRolePageList", params) };
// 管理员编辑系统角色
export const editSysRole = (params) => { return req("post", "/admin/admin/editSysRole", params) };
// 管理员删除系统角色
export const delSysRole = (params) => { return req("post", "/admin/admin/delSysRole", params) };
// 管理员查询全部权限菜单
export const getAuthMenu = (params) => { return req("post", "/admin/admin/getAuthMenu", params) };
// 管理员查询角色详情
export const getRoleInfo = (params) => { return req("post", "/admin/admin/getRoleInfo", params) };
// 查询账户权限菜单
export const getAdminPermission = (params) => { return req("post", "/admin/admin/getAdminPermission", params) };
// 查询账户权限按钮
export const getAdminBtn = (params) => { return req("post", "/admin/admin/getAdminBtn", params) };
// 管理员导出勾选的案件信息
export const importEvalCaseCheck = (params) => { return req("post", "/admin/admin/importEvalCaseCheck", params) };
// 管理员查询案件订单数据
export const getEvalCaseOrderPageList = (params) => { return req("post", "/admin/admin/getEvalCaseOrderPageList", params) };
// 管理员查询积分充值订单数据
export const getRechargeOrderPageList = (params) => { return req("post", "/admin/admin/getRechargeOrderPageList", params) };
// 管理员查询发票申请数据
export const getApplyTicketPageList = (params) => { return req("post", "/admin/admin/getApplyTicketPageList", params) };
// 管理员审核转账凭证
export const examineTransfer = (params) => { return req("post", "/admin/admin/examineTransfer", params) };
// 管理员提交发票
export const editInvoiceTicket = (params) => { return req("post", "/admin/admin/editInvoiceTicket", params) };
// 管理员查询领域分布统计表数据
export const getSysAdminAreaData = (params) => { return req("post", "/admin/platform/getSysAdminAreaData", params) };
// 管理员查询级别分布统计表数据
export const getSysAdminLevelData = (params) => { return req("post", "/admin/platform/getSysAdminLevelData", params) };
// 管理员查询评测数量统计表数据
export const getSysAdminEvalNumData = (params) => { return req("post", "/admin/platform/getSysAdminEvalNumData", params) };
// 管理员查询评测方式统计表数据
export const getSysAdminEvalTypeData = (params) => { return req("post", "/admin/platform/getSysAdminEvalTypeData", params) };
// 管理员查询用户排行统计表数据
export const getCustomerRankData = (params) => { return req("post", "/admin/platform/getCustomerRankData", params) };
// 管理员查询专家排行统计表数据
export const getAgentRankData = (params) => { return req("post", "/admin/platform/getAgentRankData", params) };
// 管理员查询用户导入excel模板
export const getImportCusExcelTemp = (params) => { return req("post", "/admin/admin/getImportCusExcelTemp", params) };
// 管理员查询统计图表可选年份数据
export const getSelectYearData = (params) => { return req("post", "/admin/platform/getSelectYearData", params) };
// 管理员获取评估报告地址
export const getSysAdminEvalReport = (params) => { return req("post", "/admin/cases/getSysAdminEvalReport", params) };
// 管理员重置用户账户密码
export const resetUserAccountPsd = (params) => { return req("post", "/admin/admin/resetUserAccountPsd", params) };
// 管理员重置用户账户密码
export const getAdminCusPointsLog = (params) => { return req("post", "/admin/admin/getAdminCusPointsLog", params) };
// 查询管理账户消息
export const getAdminMessageList = (params) => { return req("post", "/admin/message/getAdminMessageList", params) };
// 查询分配专家列表
export const getDistributeAgentList = (params) => { return req("post", "/admin/agent/getDistributeAgentList", params) };
// 运营专员分配案件给专家
export const distributeCaseToAgent = (params) => { return req("post", "/admin/cases/distributeCaseToAgent", params) };
// 管理员撤回积分充值
export const adminRevokePoints = (params) => { return req("post", "/admin/admin/revokePoints", params) };

// 管理端相关接口结束

// 专家端相关接口开始
export const getAgentInfo = (params) => { return req("post", "/admin/agent/getAgentInfo", params) };
// 查询专家待评估案件
export const getAgentCaseTask = (params) => { return req("post", "/admin/agent/getAgentCaseTask", params) };
// 查询待评估案件详情
export const getCaseTaskInfo = (params) => { return req("post", "/admin/agent/getCaseTaskInfo", params) };
// 查询待评估案件评估报告详情
export const getCaseTaskReportDataInfo = (params) => { return req("post", "/admin/agent/getCaseTaskReportDataInfo", params) };
// 专家修改密码
export const changeAgentPassword = (params) => { return req("post", "/admin/agent/changeAgentPassword", params) };
// 查询专家已完成评估任务
export const getPageCaseList = (params) => { return req("post", "/admin/agent/getPageCaseList", params) };
// 专家提交撰写内容(完成评估任务)
export const handleCaseTask = (params) => { return req("post", "/admin/agent/handleCaseTask", params) };
// 专家回退案件
export const backCaseTask = (params) => { return req("post", "/admin/agent/backCaseTask", params) };
// 机构负责人查询专家列表
export const getAgentPageDataList = (params) => { return req("post", "/admin/agent/getAgentPageList", params) };
// 机构负责人添加专家账户
export const addAgentAccount = (params) => { return req("post", "/admin/agent/addAgent", params) };
// 机构负责人修改专家账户状态
export const changeAgentStatus = (params) => { return req("post", "/admin/agent/changeAgentStatus", params) };
// 机构负责人查询机构专家的案件
export const getAgentCasePageList = (params) => { return req("post", "/admin/agent/getAgentCasePageList", params) };
// 查询专家账户消息
export const getAgentMessageList = (params) => { return req("post", "/admin/message/getAgentMessageList", params) };

// 专家端相关接口结束


export const webUrl = 'https://evalapi.qzhip.com/index.php';
export const docUrl = 'https://evalapi.qzhip.com';
// export const webUrl = 'http://evaluate.test/index.php';



// WEBPACK FOOTER //
// ./src/api/evalMG.js